import { fn, numberExpr, op } from "./shared";

import type { SemanticExpr } from "../types";

const one = () => numberExpr("1");
const cos = (arg: SemanticExpr) => fn("sp.cos", [arg]);
const sin = (arg: SemanticExpr) => fn("sp.sin", [arg]);
const atan = (arg: SemanticExpr) => fn("sp.atan", [arg]);
const tanh = (arg: SemanticExpr) => fn("sp.tanh", [arg]);

/** `1 - trig(arg)` */
const oneMinus = (trig: SemanticExpr) => op("Add", [one(), op("Neg", [trig])]);
/** `1/trig(arg) - 1` */
const recipMinusOne = (trig: SemanticExpr) =>
  op("Add", [op("Frac", [one(), trig]), op("Neg", [one()])]);

export const TRIG_IDENTITY_BUILDERS: Record<string, (arg: SemanticExpr) => SemanticExpr> = {
  "function-versine": (arg) => oneMinus(cos(arg)),
  "function-coversine": (arg) => oneMinus(sin(arg)),
  "function-exsecant": (arg) => recipMinusOne(cos(arg)),
  "function-excosecant": (arg) => recipMinusOne(sin(arg)),
  "function-haversine": (arg) => op("Frac", [oneMinus(cos(arg)), numberExpr("2")]),
  "function-hacoversine": (arg) => op("Frac", [oneMinus(sin(arg)), numberExpr("2")]),
  "function-gudermannian": (arg) =>
    op("Mul", [numberExpr("2"), atan(tanh(op("Frac", [arg, numberExpr("2")])))]),
};
